export class DocTypes {
  public static REQUESTER_DOC = 1;
  public static CONSULTANT = 2;
}

export class ExitDocTypes {
  public static REQUESTER_DOC = 1;
  public static EXIT = 2;
  public static IT_TEAM = 3;
  public static EXPENSE = 4;
  public static LMS = 5;
  public static AMEX = 6;
  public static ARC_AND_CANVAS = 7;
  public static LEADS = 8;
  public static FINANCE = 9;
  public static IMMIGRATION = 10;
  public static GUIDANCE_MAIL = 11;
  public static HRCC = 12;

}
